import { render, staticRenderFns } from "./AvatarStack.vue?vue&type=template&id=340c8b97&scoped=true"
import script from "./AvatarStack.vue?vue&type=script&lang=ts"
export * from "./AvatarStack.vue?vue&type=script&lang=ts"
import style0 from "./AvatarStack.vue?vue&type=style&index=0&id=340c8b97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340c8b97",
  null
  
)

export default component.exports